<template>
    <div>
        <top-nav></top-nav>
        <div class="page-title">
            <div class="container">
                <span class="icon icon-engine"></span>
                <h1>{{pageTitle}}</h1>
                <span
                    v-if="factoryEngine.uid"
                    class="icon-bin"
                    @click="openDialog('engineDelete')"></span>
            </div>
        </div>
        <el-dialog v-if="factoryEngine.uid" :visible.sync="engineDelete" :title="getText('motor_dialog_title')" center>
            <span>{{getText('motor_dialog_text')}}<strong>{{factoryEngine.name}}</strong> ?</span>
            <span slot="footer" class="dialog-footer">
                <div class="dialogButtons">
                    <el-button class="whiteButton" @click="closeDialog('engineDelete')">{{getText('cancel_button')}}</el-button>
                    <el-button class="greenButton" v-loading="loadings.delete" :disabled="loadings.delete" @click="deleteEngine">{{getText('dialog_confirm_archive_button')}}</el-button>
                </div>
            </span>
        </el-dialog>

        <stepper
            :loading="loadings.save"
            :factoryEngine="factoryEngine"
            @cancel="cancel"
            :rules="rules"
            @save="save"
        >
            <step slot="main" name="Plaque Moteur">
                <plaque-moteur-form
                    :rules = "rules"
                    :factoryEngine = "factoryEngine"
                ></plaque-moteur-form>
            </step>
            <step slot="main" name="Type d'application'">
                <application-type-form
                    :rules = "rules"
                    :factoryEngine = "factoryEngine"
                ></application-type-form>
            </step>
            <step slot="main" name="Type de régulation">
                <regulation-form
                    :rules = "rules"
                    :factoryEngine = "factoryEngine"
                ></regulation-form>
            </step>
            <step slot="main" name="Machine">
                <machine-form
                    :rules = "rules"
                    :factoryEngine = "factoryEngine"
                    :factoryMachine = "factoryEngine.trained_machine"
                    @changeInfoType="changeInfoType"
                ></machine-form>
            </step>
            <step slot="main" name="Données">
                <donnees-form
                    :rules = "rules"
                    :factoryEngine = "factoryEngine"
                ></donnees-form>
            </step>
        </stepper>

        <page-footer></page-footer>

    </div>
</template>

<script>
import Step from '../partials/wizzard/Step.vue';
import Stepper from '../partials/wizzard/Stepper.vue';
import PlaqueMoteurForm from '../partials/wizzard/PlaqueMoteurForm.vue';
import RegulationForm from '../partials/wizzard/RegulationForm.vue';
import ApplicationTypeForm from '../partials/wizzard/ApplicationTypeForm.vue';
import MachineForm from '../partials/wizzard/MachineForm.vue';
import DonneesForm from '../partials/wizzard/DonneesForm.vue';

import topNav from '../ui/top-nav.vue';
import pageTitle from '../ui/page-title.vue';
import pageFooter from '../ui/page-footer.vue';
import {mapGetters} from 'vuex';

export default {
    data() {
        function checkNominalPower (rule, value, callback) {
            if (value > 9999 || value < 1) {
                callback(new Error());
            } else {
                callback();
            }
        }
        function checkNominalVoltage (rule, value, callback) {
            if (value > 400 || value < 380) {
                callback(new Error());
            } else {
                callback();
            }
        }
        function checkNominalIntensity (rule, value, callback) {
            if (value > 2000 || value < 3) {
                callback(new Error());
            } else {
                callback();
            }
        }
        function checkCosPhi (rule, value, callback) {
            if (value > 0.95 || value < 0.6) {
                callback(new Error());
            } else {
                callback();
            }
        }
        function checkNominalSpeed (rule, value, callback) {
            if ((value >= 1400 && value <= 1500) || (value >= 2900 && value <= 2999)) {
                callback();
            } else {
                callback(new Error());
            }
        }
        function checkRegulation (rule, value, callback) {
            (value != '') ? callback() : callback(new Error());
        }
        function checkEfficiency (rule, value, callback) {
            if (value != '') {
                (value <= 1 && value >= 0) ? callback() : callback(new Error());
            }
            callback(new Error());
        }
        function checkWorkingTime (rule, value, callback) {
            if (value != '') {
                (value <= 8760 && value >= 0) ? callback() : callback(new Error());
            }
            callback(new Error());
        }
        return {
            loadings: {
                save: false,
                delete: false
            },
            engineDelete: false,
            lang: this.getLangage,
            factoryEngine: {
                name: '',
                comment: '',
                nominal_power: '',
                nominal_voltage: '',
                nominal_current: '',
                cos_phi: '',
                nominal_speed: '',
                casing_type: '',
                application_type: '',
                regulation_type: '',
                trained_machine: {
                    infoTypeSelected: null,
                    pressure: 0,
                    pressure_unit: '',
                    flow: 0,
                    flow_unit: '',
                    efficiency: '',
                    pn_me: '',
                },
                annual_working_time: '',
                number: 1,
                intensity_max: '', // ?
            },
            rules: {
                name: {
                    required: true,
                    message: this.$store.getters.getText('motor_form_name_error_message'),
                    trigger: 'blur'
                },
                nominal_power: {
                    required: true,
                    validator: checkNominalPower,
                    message: this.$store.getters.getText('motor_form_nominal_power_error_message'),
                    trigger: 'blur'
                },
                nominal_voltage: {
                    required: true,
                    validator: checkNominalVoltage,
                    message: this.$store.getters.getText('motor_form_nominal_voltage_error_message'),
                    trigger: 'blur'
                },
                nominal_current: {
                    required: true,
                    validator: checkNominalIntensity,
                    message: this.$store.getters.getText('motor_form_nominal_current_error_message'),
                    trigger: 'blur'
                },
                cos_phi: {
                    required: true,
                    validator: checkCosPhi,
                    message: this.$store.getters.getText('motor_form_cos_phi_error_message'),
                    trigger: 'blur'
                },
                nominal_speed: {
                    required: true,
                    validator: checkNominalSpeed,
                    message: this.$store.getters.getText('motor_form_nominal_speed_error_message'),
                    trigger: 'blur'
                },
                casing_type: {
                    required: true,
                    trigger: 'blur',
                    message: this.$store.getters.getText('motor_form_name_structure_type_error_message'),
                },
                application_type: {
                    required: true,
                    trigger: 'blur',
                    message: this.$store.getters.getText('motor_form_name_application_type_error_message'),
                },
                regulation_type: {
                    required: true,
                    trigger: 'blur',
                    validator: checkRegulation,
                    message: this.$store.getters.getText('motor_form_regulation_type_error_message')
                },
                trained_machine: {
                    infoTypeSelected: {
                        required: true,
                        trigger: 'blur'
                    },
                    pn_me: {
                        required: true,
                        trigger: 'blur',
                        message: this.$store.getters.getText('motor_form_machine_power_error_message')
                    },
                    pressure: {
                        required: true,
                        trigger: 'blur',
                        message: this.$store.getters.getText('motor_form_machine_pressure_error_message')
                    },
                    pressure_unit: {
                        required: true,
                        trigger: 'blur',
                        message: this.$store.getters.getText('motor_form_machine_pressure_unit_error_message')
                    },
                    flow: {
                        required: true,
                        trigger: 'blur',
                        message: this.$store.getters.getText('motor_form_machine_output_error_message')
                    },
                    flow_unit: {
                        required: true,
                        trigger: 'blur',
                        message: this.$store.getters.getText('motor_form_machine_output_unit_error_message')
                    },
                    efficiency: {
                        required: true,
                        trigger: 'blur',
                        validator: checkEfficiency,
                        message: this.$store.getters.getText('motor_form_machine_efficiency_error_message')
                    }
                },
                annual_working_time: {
                    required: true,
                    trigger: 'blur',
                    validator: checkWorkingTime,
                    message: this.$store.getters.getText('motor_form_working_duration_error_message'),
                },
            },
        };
    },
    components: {
        Step, Stepper, PlaqueMoteurForm, RegulationForm, ApplicationTypeForm, MachineForm, DonneesForm, topNav, pageTitle, pageFooter
    },
    computed: {
        ...mapGetters([
            'factoryEnginesByUid',
            'getLangage',
            'getText'
        ]),
        getFactoryEngine() {
            let engine = this.factoryEnginesByUid(this.$route.params.uid);
            if(engine){
                if (!engine.machine) {
                    engine.machine = {
                        name: '',
                        pressure: '',
                        pressure_unit: '',
                        output: '',
                        output_unit: '',
                        yieldPercent: '',
                        power: ''
                    };
                }
                return engine;
            }
            return {
                name: 'loading'
            };
        },
        pageTitle() {
            return this.factoryEngine.name ? this.factoryEngine.name : this.getText('motor_default_title');
        },
    },
    mounted() {
        if(this.$store.state.importableMotorData){
            let motorData = this.$store.state.importableMotorData.motor_data;
            if(this.$store.state.importableMotorData.motor_data.mode === 'simple'){
                motorData.application_type = '';
                motorData.regulation_type = '';
                motorData.trained_machine =  {
                    infoTypeSelected: null,
                    pressure: 0,
                    pressure_unit: '',
                    flow: 0,
                    flow_unit: '',
                    efficiency: '',
                    pn_me: '',
                };
            }else{
                // In motorview infoTypeSelected is called type
                motorData.trained_machine.infoTypeSelected = this.$store.state.importableMotorData.motor_data.trained_machine.type;
                delete motorData.trained_machine.type;
            }
            motorData.number = 1;
            motorData.casing_type = '';
            motorData.intensity_max = '';
            this.factoryEngine = JSON.parse(JSON.stringify(motorData));
        }
        if (this.$route.params.uid && this.factoryEngine.uid == null) {
            this.factoryEngine = JSON.parse(JSON.stringify(this.getFactoryEngine));
        }
        if (this.lang != this.getLangage) {
            this.changeRuleLangage();
            this.lang = this.getLangage;
        }
    },
    beforeDestroy(){
        this.$store.commit('CLEAR_IMPORTABLE_DATA');
    },
    methods: {
        changeInfoType(value) {
            this.$set(this.factoryEngine.trained_machine, 'infoTypeSelected', value);
        },
        changeRuleLangage() {
            this.rules.name.message = this.getText('motor_form_name_error_message');
            this.rules.nominal_power.message = this.getText('motor_form_nominal_power_error_message');
            this.rules.nominal_voltage.message = this.getText('motor_form_nominal_voltage_error_message');
            this.rules.nominal_current.message = this.getText('motor_form_nominal_current_error_message');
            this.rules.cos_phi.message = this.getText('motor_form_cos_phi_error_message');
            this.rules.nominal_speed.message = this.getText('motor_form_nominal_speed_error_message');
            this.rules.casing_type.message = this.getText('motor_form_name_structure_type_error_message');
            this.rules.application_type.message = this.getText('motor_form_name_application_type_error_message');
            this.rules.regulation_type.message = this.getText('motor_form_regulation_type_error_message');
            this.rules.trained_machine.pn_me.message = this.getText('motor_form_machine_power_error_message');
            this.rules.trained_machine.pressure.message = this.getText('motor_form_machine_pressure_error_message');
            this.rules.trained_machine.flow.message = this.getText('motor_form_machine_output_error_message');
            this.rules.trained_machine.pressure_unit.message = this.getText('motor_form_machine_pressure_unit_error_message');
            this.rules.trained_machine.flow_unit.message = this.getText('motor_form_machine_output_unit_error_message');
            this.rules.trained_machine.efficiency.message = this.getText('motor_form_machine_efficiency_error_message');
            this.rules.annual_working_time.message = this.getText('motor_form_working_duration_error_message');
        },
        save(){
            this.saveEngine();
        },
        cancel(){
            this.$router.go(-1);
        },
        deleteEngine() {
            this.loadings.delete = true;
            this.$store.dispatch('patchItem', {
                item : {
                    url: this.factoryEngine.url,
                    archived: true
                },
                model: 'factoryEngines',
            }).then(response => {
                this.$notify({
                    type: 'success',
                    title: this.getText('notify_success_title'),
                    message: this.getText('notify_engine_delete_successful')
                });
                this.closeDialog('engineDelete');
                this.loadings.delete = false;
                this.$router.push({ name: 'moteurs', params: { siteid: this.$route.params.siteid }});
            }).catch(() => {
                this.closeDialog('engineDelete');
                this.$notify({
                    type: 'error',
                    title: this.getText('notify_failed_title'),
                });
                this.loadings.delete = false;
            })
        },
        closeDialog(ref) {
            this[ref] = false;
        },
        openDialog(ref) {
            this[ref] = true;
        },
        ensureFloat(value){
            let v = parseFloat(value);
            if(isNaN(v)){
                return 0.0;
            }
            return v;
        },
        saveEngine() {
            let method = 'createItem';
            if (this.factoryEngine.application_type === 'motor') {
                this.factoryEngine.regulation_type = 'no_adjustment';
                this.factoryEngine.trained_machine.pn_me = this.factoryEngine.nominal_power;
            }
            if (this.factoryEngine.trained_machine.infoTypeSelected === 'other') {
                let pn_me = this.$store.getters.computePowerForFlowAndPressureInWatt({
                    flow_value: this.factoryEngine.trained_machine.flow,
                    flow_unit: this.factoryEngine.trained_machine.flow_unit,
                    pressure_value: this.factoryEngine.trained_machine.pressure,
                    pressure_unit: this.factoryEngine.trained_machine.pressure_unit,
                    fluid_type: 'eau',
                    efficiency: this.factoryEngine.trained_machine.efficiency,
                });

                pn_me = parseInt(pn_me) / 1000;
                this.factoryEngine.trained_machine.pn_me = pn_me
            }
            let newEngine = {
                item: this.factoryEngine,
                model: 'factoryEngines'
            };
            if (this.$route.params.uid) {
                this.loadings.save = true;
                method = 'updateItem';
            }
            else {
                this.loadings.save = true;
                newEngine.item.factory_uid = this.$route.params.siteid,
                newEngine.url = this.$store.state.api.meta.listModels.factoryEngines.url;
            }
            if(this.$store.state.importableMotorData){
                newEngine.item.importable_motor_uid = this.$store.state.importableMotorData.uid;
            }
            this.$store.dispatch(method, newEngine).then(() => {
                if (method === 'updateItem') {
                    this.$notify({
                        type: 'success',
                        title: this.getText('notify_success_title'),
                        message: this.getText('notify_engine_update_successful')
                    });
                }
                else {
                    this.$notify({
                        type: 'success',
                        title: this.getText('notify_success_title'),
                        message: this.getText('notify_engine_create_successful')
                    });
                }
                this.loadings.save = false;
                this.loadings.delete = false;
                this.$router.push({ name: 'moteurs', params: { siteid: this.$route.params.siteid }});
            }).catch(() => {
                this.$notify({
                    type: 'error',
                    title: this.getText('notify_failed_title'),
                });
                this.loadings.save = false;
                this.loadings.delete = false;
            });
        }
    },
};

</script>

<style lang="less">

@import '../../less/variables';

.page-title {
    margin-bottom: 0px;
}

.el-step__head.is-finish {
    color: @color-1;
    border-color: @color-1;
}
.el-step__title.is-finish {
    color: @color-1;
}

.el-form-item.is-error .el-input__inner, .el-form-item.is-error .el-input__inner:focus, .el-form-item.is-error .el-textarea__inner, .el-form-item.is-error .el-textarea__inner:focus, .el-message-box__input input.invalid, .el-message-box__input input.invalid:focus {
    border-color: @color-1;
}
</style>



// WEBPACK FOOTER //
// src/components/page/moteur.vue